import { Component, OnInit } from '@angular/core';
import { ParamsService } from 'elbuild-ui-lib-core';
import { Router, ActivatedRoute } from '@angular/router';
import { ListFiltersComponent } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-tender-list-filters',
	templateUrl: './tender-list-filters.component.html',
	styleUrls: ['./tender-list-filters.component.scss']
})
export class TenderListFiltersComponent extends ListFiltersComponent implements OnInit {

	keyword: string;

	constructor(
		router: Router,
		_route: ActivatedRoute,
		paramsService: ParamsService,
	) {
		super(router, _route, paramsService);
	}

	ngOnInit() {
	}

	search(keeppage?: boolean) {
		super.search(keeppage);
	}

	set showonlyopen(sop: boolean) {
		if (sop) {
			const start = Math.floor(new Date().getTime() / 1000);
			const stop = Number.MAX_VALUE;
			this.searchparams.addRangeFilter('projectdeadline', start, stop);
		} else {
			this.searchparams.removeRangeFilter('projectdeadline');
		}
	}

}
